module.exports = __webpack_public_path__ + "static/img/feedback.8ae1fc95.png";